import Immutable, { List, Map } from 'immutable';

import { 
    HANDLE_COLUMN_INPUT, 
    CLEAR_FROM_STATE,
    HANDLE_NAME_INPUT,
    SET_ALL_TEMPLATES,
    ADD_TEMPLATE_TO_TABLE,
    SET_TEMPLATE_ID,
    SET_TEMPLATE_STATE,
    OPEN_MODAL,
    HANDLE_SECONDARY_ROW_COMMAND,
    HANDLE_SECONDARY_ROW_COMMAND_VALUE,
    HANDLE_INCLUDE_SUBTOTALS,
} from './ACTION_TYPES';

import { 
    CREATE_EXCEPTION,
    MINIMUM_VALUE,
    MAXIMUM_VALUE,
    SEGMENT_BY,
    TEMPLATE_TYPE,
    COLUMN_SORT_ORDER,
    APPLICATION,
    NONE,
    TEMPLATE_NAME,
    DISTANCE,
    NEW_SEGMENTS_WHEN_CLEARED,
    SPLIT_LEFT_RIGHT_SEGMENTS,
    AMOUNT,
    SEGMENT_COMBINE_PATTERNS_BY_JOB,
    SECONDARY_ROW_COMMAND,
    SECONDARY_ROW_COMMAND_VALUE,
    INCLUDE_SUBTOTALS,
    JOB,
    ENTRY_FIELD,
    BATCH,
    TIME,
    LINE_TYPE,
} from '../configs/KEY_NAMES';


const SELECT_TEMPLATE_TO_SHARE = 'SELECT_TEMPLATE_TO_SHARE';
export const setShareTemplateID = (shareID)=> ({
    type: SELECT_TEMPLATE_TO_SHARE,
    shareID,

});

export const openFormModal = () => ({
    type: OPEN_MODAL
});

export const setTemplateState = (templateState) => ({
    type: SET_TEMPLATE_STATE,
    templateState
});

export const setTemplateID = (templateID, isRetro) => ({
    type: SET_TEMPLATE_ID,
    templateID,
    isRetro,

});

export const setAllTemplates = (allTemplates) => ({
    type: SET_ALL_TEMPLATES,
    allTemplates
});

export const addTemplateToTable = (newTemplate) => ({
    type: ADD_TEMPLATE_TO_TABLE,
    newTemplate
});

export const handleColumnInput  = ( _id, value, defaultValues=null ) => ({
    type: HANDLE_COLUMN_INPUT,
    _id,
    value,
    defaultValues,
});

export const clearFormState = () => ({
    type: CLEAR_FROM_STATE
});

const TOGGLE_RETRO_TEMPLATE = 'TOGGLE_RETRO_TEMPLATE';
export const toggleRetroTemplate = () => ({
    type: TOGGLE_RETRO_TEMPLATE,
});

export const handleTemplateNameInput = (name) => ({
    type: HANDLE_NAME_INPUT,
    name
})

export const handleSecondaryRowCommand = (value) => ({
    type: HANDLE_SECONDARY_ROW_COMMAND,
    value
});

export const handleSecondaryRowCommandValue = (value) => ({
    type: HANDLE_SECONDARY_ROW_COMMAND_VALUE,
    value
});

export const handleIncludeSubtotals = (value) => ({
    type: HANDLE_INCLUDE_SUBTOTALS,
    value
});

const handleSegmentByOnly = (oldState, newFormState) => {
    const middleKey = oldState.getIn([SEGMENT_BY, 'value']);
    newFormState = newFormState.set(SEGMENT_BY, middleKey);
    oldState = oldState.deleteIn([SEGMENT_BY, 'value']);

    const segmentBySubKeys = oldState.get(SEGMENT_BY, Map({})).keySeq();

    segmentBySubKeys.forEach(subKey => {
        let newKey = `${SEGMENT_BY}/${middleKey}/${subKey}`;
        if (
            subKey === NEW_SEGMENTS_WHEN_CLEARED 
            || subKey === SPLIT_LEFT_RIGHT_SEGMENTS
            || subKey === SEGMENT_COMBINE_PATTERNS_BY_JOB
        ){
            newKey = `${SEGMENT_BY}/${subKey}`
        }
        if (
            subKey === MINIMUM_VALUE
            || subKey === MAXIMUM_VALUE
        ) {

        };
        const value = oldState.getIn([SEGMENT_BY, subKey]);
        newFormState = newFormState.set(newKey, value);
    });

    return newFormState;
}

function reverseSegmentByTransformation(payload, result) {
    let segmentBy = payload.get('segment_by');
    const middleKey = payload.getIn([SEGMENT_BY, 'top_level_segment_type']);
    segmentBy = segmentBy.delete('top_level_segment_type');

    
    // Handle secondary_row_command related properties
    if (segmentBy.get('value')) {
        result = result.set('secondary_row_command_value', segmentBy.get('value'));

        // Handle nested distance properties
        if (segmentBy.get('amount')) {
            result = result.set(`secondary_row_command/${segmentBy.get('value')}/amount`, segmentBy.get('amount'));
            console.log('result', result);
            segmentBy = segmentBy.delete('amount');
        }
        if (segmentBy.get('unit')) {
            result = result.set(`secondary_row_command/${segmentBy.get('value')}/unit`, segmentBy.get('unit'));
            console.log('result', result.toJS());
            segmentBy = segmentBy.delete('unit');
        }
        segmentBy = segmentBy.delete('value');
    }
    if (segmentBy.get('top_level_amount')) {
        result = result.set(`${SEGMENT_BY}/${middleKey}/amount`, segmentBy.get('top_level_amount'));
        segmentBy = segmentBy.delete('top_level_amount');
    }
    if (segmentBy.get('top_level_unit')) {
        result = result.set(`${SEGMENT_BY}/${middleKey}/unit`, segmentBy.get('top_level_unit'));
        segmentBy = segmentBy.delete('top_level_unit');
    }

    // Handle the main segment_by value
    result = result.set(SEGMENT_BY, middleKey);
    result = result.set('secondary_row_command', true);

    const segmentBySubKeys = segmentBy.keySeq();

    segmentBySubKeys.forEach(subKey => {
        let newKey = `${SEGMENT_BY}/${middleKey}/${subKey}`;
        if (
            subKey === NEW_SEGMENTS_WHEN_CLEARED 
            || subKey === SPLIT_LEFT_RIGHT_SEGMENTS
            || subKey === SEGMENT_COMBINE_PATTERNS_BY_JOB
        ){
            newKey = `${SEGMENT_BY}/${subKey}`
        }
        if (
            subKey === MINIMUM_VALUE
            || subKey === MAXIMUM_VALUE
        ) {

        };
        const value = segmentBy.get(subKey);
        result = result.set(newKey, value);
    });



    /* // Handle segment_by nested properties */
    /* if (segmentBy.get('top_level_segment_type')) { */
    /*     result = result.set( */
    /*         `${SEGMENT_BY}/${segmentBy.get('top_level_segment_type')}/amount`, */ 
    /*         segmentBy.get('top_level_amount') */
    /*     ); */
    /* } */

    return result;
}

const formatData = (oldState) => {
    let newFormState = Map({});
    const columnsSortOrder = oldState.get('columnsSortOrder', List([]));
    const name = oldState.get('name');
    const templateType = oldState.get(TEMPLATE_TYPE);

    // Handle truck_summaries -> include_subtotals transformation
    if (oldState.has('truck_summaries')) {
        newFormState = newFormState.set(`${SEGMENT_BY}/include_subtotals`, oldState.get('truck_summaries'));
    }

    newFormState = newFormState.set('columnsSortOrder', columnsSortOrder);
    newFormState = newFormState.set('name', name);
    newFormState = newFormState.set(TEMPLATE_TYPE, templateType);
    columnsSortOrder.forEach(key => {
        newFormState = newFormState.set(key, true);

        const subKeys = oldState.get(key, Map({})).keySeq();

        subKeys.forEach(subKey => {
            const newKey = `${key}/${subKey}`;
            const value = oldState.getIn([key, subKey]);
            if (subKey ===  MINIMUM_VALUE || subKey === MAXIMUM_VALUE){
                const createExceptionKey = `${key}/${CREATE_EXCEPTION}`;
                if (!newFormState.has(createExceptionKey)){
                    newFormState  = newFormState.set(createExceptionKey, true);
                }
            };
            newFormState = newFormState.set(newKey, value);
        });


    });

    const segmentByObj = oldState.get(SEGMENT_BY, Map({}));
    if (segmentByObj.has('top_level_segment_type')){
        newFormState = reverseSegmentByTransformation(oldState, newFormState);
        // handle this
    } else {
        newFormState = handleSegmentByOnly(oldState, newFormState);
    }

    return newFormState;
};

let  initalState = Immutable.fromJS({
    // template_type: APPLICATION, // the  template type
    // template_type: 'retroreflectivity', // the  template type
    // segment_by: NONE, // the  template type
    // columnsSortOrder: [], // array of keys to sign;
    // name: '',
    allTemplates: [],
    templateModalOpen: false,
    shareTemplateID: '',
    retroTemplate: false,
});

const templateOptionsInit = Immutable.fromJS({
    template_type: APPLICATION, // the  template type
    segment_by: NONE, // the  template type
    columnsSortOrder: [], // array of keys to sign;
    name: '',
});

initalState = initalState.merge(templateOptionsInit);


const templatesReducer = (state=initalState, action) => {
    switch(action.type){

        case SELECT_TEMPLATE_TO_SHARE:
            const { shareID='' } =action;
            return state.set('shareTemplateID', shareID)

        case SET_TEMPLATE_ID:
            const { templateID, isRetro } = action;
            return state
                .set('templateID', templateID)
                .set('templateModalOpen', true)
                .set('retroTemplate', isRetro);

        case SET_TEMPLATE_STATE:
            const { templateState } = action;
            let newTemplateState = formatData(templateState);
            return state.merge(newTemplateState);


        case OPEN_MODAL:
            return state.set('templateModalOpen', true);

        case TOGGLE_RETRO_TEMPLATE:
            const currentRetroState = state.get('retroTemplate', false);
            let resetState = templateOptionsInit
                .set('retroTemplate', !currentRetroState)
                .set('templateModalOpen', true)
                .set('shareTemplateID', state.get('shareTemplateID', ''))
                .set('allTemplates', state.get('allTemplates', List([])))

            if (!currentRetroState){
                resetState = resetState.set('template_type', 'retro')
            } else {
                resetState = resetState.set('template_type', APPLICATION)
            }
            return resetState;

        case SET_ALL_TEMPLATES:
            const { allTemplates } = action;
            return state.set('allTemplates', allTemplates);

        case HANDLE_NAME_INPUT:
            const {name} = action
            return state.set('name', name)

        case HANDLE_COLUMN_INPUT:

            let {_id, value, defaultValues} = action;
            console.log('_id', _id);
            console.log('value', value);
            console.log('defaultValues', defaultValues);

            const idsArray = _id.split('/');
            const mainID = idsArray[0];
            const secondaryID = idsArray[1] || '';
            const unitID = idsArray[2] || '';


            let columnSortOrder = state.get('columnsSortOrder', List([]));

            // keeping track of the column order
            // does not apply to segment_by,template_type, or template name 
            // only for the first column in the rows whos idsArray length will always be 1
            // average_speed not average_speed/units
            // only used for checkboxes where value is true or false
            if (
                mainID !== SEGMENT_BY 
                && mainID !== SECONDARY_ROW_COMMAND
                && mainID !== TEMPLATE_TYPE 
                && mainID !== TEMPLATE_NAME
                && idsArray.length === 1
            ){
                if (value === false && mainID){
                    const columnIndex = columnSortOrder.indexOf(mainID);
                    if (columnIndex !== -1){
                        columnSortOrder = columnSortOrder.delete(columnIndex);
                    }
                } else {
                    columnSortOrder = columnSortOrder.push(mainID);
                };

            }

            // value here is a number
            if (secondaryID === COLUMN_SORT_ORDER) {
                const columnIndex = columnSortOrder.indexOf(mainID);
                columnSortOrder = columnSortOrder.splice(columnIndex, 1);
                columnSortOrder = columnSortOrder.splice(value-1, 0, mainID);
            };

            // if (_id === `${SEGMENT_BY}/${DISTANCE}/${AMOUNT}`){
            //     value = value === '' ? 0 : value;
            // };

            let updatedState =  state
                .set(_id, value)
                .set('columnsSortOrder', columnSortOrder);

            if (mainID === SEGMENT_BY && !secondaryID && value !== ENTRY_FIELD) {
                console.log('value', value);
                const secondaryRowCommandValue = state.get(SECONDARY_ROW_COMMAND_VALUE, '');
                if (value === secondaryRowCommandValue) {
                    updatedState = updatedState.set(SECONDARY_ROW_COMMAND_VALUE, '');
                }

                const isSegmentByAllowed = value === ENTRY_FIELD || value === TIME || value === BATCH || value === LINE_TYPE;
                if (!isSegmentByAllowed) {
                    updatedState = updatedState.set(SECONDARY_ROW_COMMAND, false);
                }
            }

            // when a row is first selected we set the provided default values 
            // We don't want this default values to override values that have
            // already been selected in cases where a row is selected,
            // deslected, then selected again. To prevent that, we merge the
            // current state into the default values, that way if any of them
            // already exist they will overrite the default values.  
            if (defaultValues !== null){
                const _defaultValuesImm = Immutable.fromJS(defaultValues);
                console.log('_defaultValuesImm', _defaultValuesImm.toJS());
                updatedState = Immutable.merge(_defaultValuesImm, updatedState);
                console.log('updatedState', updatedState.toJS());
            };


            return state.merge(updatedState);

        case CLEAR_FROM_STATE:
            const currentTemplates = state.get('allTemplates', List([]));
            let newState = initalState.set('allTemplates', currentTemplates);
            newState = newState.merge(templateOptionsInit);
            return newState;

        case HANDLE_SECONDARY_ROW_COMMAND:
            console.log('action.value', action.value);
            return state.set(SECONDARY_ROW_COMMAND, action.value);

        case HANDLE_SECONDARY_ROW_COMMAND_VALUE:
            console.log('action.value secon', action.value);
            return state.set(SECONDARY_ROW_COMMAND_VALUE, action.value);



        default:
            return state;
    }
};

export default templatesReducer;
